import type { IBaseRecipient, INotificationRule, INotificationRuleTemplate, IRecipient, RecipientProvider } from '@condo/domain';
import { omit } from 'lodash-es';
import { getClient } from './api-client';

export const getUserNotificationRules = async (userUid: string, notificationRuleTemplateId?: number): Promise<INotificationRule[]> =>
    getClient('basecamp')
        .get(`notification/notification-rules`, {
            params: {
                notificationRuleTemplateId,
                userUid,
            },
        })
        .then(response => response.data.notificationRules);

export const getNotificationRuleTemplates = async (): Promise<INotificationRuleTemplate[]> =>
    getClient('basecamp')
        .get('notification/notification-rule-templates')
        .then(response => response.data.notificationRuleTemplates);

export const updateNotificationRule = async (notificationRule: INotificationRule): Promise<INotificationRule> =>
    getClient('basecamp')
        .put(`notification/notification-rules/${notificationRule.notificationRuleId}`, {
            notificationRule: omit(notificationRule, ['notificationRuleId', 'updatedAt', 'createdAt']),
        })
        .then(response => response.data.notificationRule);

export const getNotificationRecipients = async (provider: RecipientProvider): Promise<IRecipient[]> =>
    getClient('basecamp')
        .get(`notification/recipients?provider=${provider}`)
        .then(response => response.data.recipients);

export const upsertRecipient = async (recipient: IBaseRecipient): Promise<IBaseRecipient> =>
    getClient('basecamp')
        .post(`notification/recipients`, { recipient })
        .then(response => response.data.recipient);

export const deleteRecipient = async (recipient: IBaseRecipient): Promise<IBaseRecipient> =>
    getClient('basecamp').delete(`notification/recipients/${recipient.userUid}`);

export const deleteNotificationRule = async (notificationRuleId: number): Promise<void> =>
    getClient('basecamp').delete(`notification/notification-rules/${notificationRuleId}`);

export const deleteNotificationRuleForUser = async (userUid: string): Promise<void> =>
    getClient('basecamp').delete(`notification/notification-rules/user/${userUid}`);

export const generateNotificationRule = async (
    rules: { templateName: string; tokens: Record<string, any> }[],
    user?: { uid: string; email?: string },
): Promise<INotificationRule[]> =>
    getClient('basecamp')
        .post('notification/notification-rules', {
            rules,
            user,
        })
        .then(response => response.data.notificationRules);
